<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> ایجاد منبع جدید برای زبان </template>
    <BRow class="mb-2">
      <BCol cols="12">
        <LanguagePicker @getLanguage="setLanguageId"></LanguagePicker>
      </BCol>
      <BCol cols="12">
        <hr />
      </BCol>
      <BCol cols="6">
        <h3>منابع</h3>
      </BCol>
      <BCol cols="auto" class="ml-auto">
        <BButton variant="success" @click="addNewResourceDetail">
          افزودن منبع
        </BButton>
      </BCol>
    </BRow>
    <BRow
      class="mb-1"
      v-for="(resource, index) in resourceDetails"
      :key="index"
    >
      <BCol cols="12">
        <TextInput
          customRules="required|min:1"
          :inputId="`resource${index}title`"
          :inputLabel="`عنوان منبع ${index + 1}`"
          inputPlaceholder="مقدماتی..."
          v-model="resource.title"
        ></TextInput>
        <BFormGroup
          :label="`تصویر نمایشی منبع ${index + 1}`"
          :label-for="`imageFile${index}`"
        >
          <BFormFile
            v-model="resource.imageFile"
            ref="imageFile"
            :id="`imageFile${index}`"
            accept=".jpg,.jpeg,.png"
            @input="handleImageFile(index)"
          ></BFormFile>
        </BFormGroup>
      </BCol>
      <BCol cols="12" class="position-relative" v-if="resource.imagePreview">
        <BRow>
          <BCol class="mx-auto" cols="6">
            <BImg fluid-grow :src="resource.imagePreview" height="300"></BImg>
          </BCol>
        </BRow>
        <BButton
          size="sm"
          variant="transparent"
          class="custom-delete-btn"
          @click="deletePreviewImage(index)"
        >
          <FeatherIcon size="40" class="text-danger" icon="Trash2Icon" />
        </BButton>
      </BCol>
      <BCol cols="auto" class="ml-auto mt-1">
        <BButton variant="danger" size="sm" @click="removeResource(index)">
          حذف منبع
        </BButton>
      </BCol>
      <BCol v-if="isLastResourceItem(index)" cols="12">
        <hr />
      </BCol>
    </BRow>
    <BRow>
      <BCol cols="auto" class="ml-auto mt-2">
        <BButton
          variant="success"
          :disabled="isSubmitButtonDisabled"
          @click="sendCreateNewResourceRequest"
        >
          ثبت
        </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      createNewLanguageResourcePayload: {
        languageId: null,
        resourceDetails: [
          {
            title: null,
            imageFile: null,
            imagePreview: null,
          },
        ],
      },
    };
  },
  methods: {
    generateFormData() {
      let formData = new FormData();
      formData.append(
        "LanguageId",
        this.createNewLanguageResourcePayload.languageId
      );
      this.createNewLanguageResourcePayload.resourceDetails.forEach(
        (item, index) => {
          formData.append(`ResourceDetails[${index}].title`, item.title);
          formData.append(
            `ResourceDetails[${index}].imageFile`,
            item.imageFile
          );
        }
      );
      return formData;
    },
    handleImageFile(index) {
      if (
        this.resourceDetails &&
        this.resourceDetails[index] &&
        this.resourceDetails[index].imageFile
      ) {
        this.createNewLanguageResourcePayload.resourceDetails[
          index
        ].imagePreview = URL.createObjectURL(
          this.resourceDetails[index].imageFile
        );
      }
    },
    deletePreviewImage(index) {
      if (
        this.resourceDetails[index] &&
        this.resourceDetails[index].imageFile
      ) {
        let selectedResource =
          this.createNewLanguageResourcePayload.resourceDetails[index];
        URL.revokeObjectURL(selectedResource.imagePreview);
        selectedResource.imagePreview = null;
        selectedResource.imageFile = null;
        if (this.$refs.imageFile && this.$refs.imageFile[index]) {
          this.$refs.imageFile[index].reset();
        }
      }
    },
    setLanguageId(langId) {
      this.createNewLanguageResourcePayload.languageId = langId;
    },
    addNewResourceDetail() {
      this.createNewLanguageResourcePayload.resourceDetails.push({
        title: null,
        imageFile: null,
        imagePreview: null,
      });
    },
    isLastResourceItem(index) {
      return index + 1 < this.resourceDetails.length;
    },
    removeResource(index) {
      if (this.createNewLanguageResourcePayload.resourceDetails[index]) {
        this.createNewLanguageResourcePayload.resourceDetails.splice(index, 1);
      }
    },
    async sendCreateNewResourceRequest() {
      try {
        this.isLoading = true;
        let _this = this;
        let createANewResourceForLanguage = new CreateANewResourceForLanguage(
          _this
        );
        createANewResourceForLanguage.setFormData(_this.generateFormData());
        await createANewResourceForLanguage.sendFormData((res) => {
          if (res.data.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "منابع شما با موفقیت ایجاد شد.",
              },
            });
            _this.createNewLanguageResourcePayload = {
              languageId: null,
              resourceDetails: [
                {
                  title: null,
                  imageFile: null,
                  imagePreview: null,
                },
              ],
            };
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ایجاد نشد!",
                icon: "XIcon",
                variant: "danger",
                text:
                  res.data.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    resourceDetails() {
      return this.createNewLanguageResourcePayload.resourceDetails;
    },
    isSubmitButtonDisabled() {
      if (
        this.createNewLanguageResourcePayload.languageId &&
        this.createNewLanguageResourcePayload.resourceDetails &&
        this.createNewLanguageResourcePayload.resourceDetails.length > 0 &&
        this.createNewLanguageResourcePayload.resourceDetails.every(
          (resource) => resource.imageFile && resource.title
        )
      ) {
        return false;
      }
      return true;
    },
  },
  components: {
    PageWrapper,
    LanguagePicker,
    BRow,
    BCol,
    BButton,
    TextInput,
    BFormGroup,
    BFormFile,
    BImg,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import LanguagePicker from "@/views/components/Language/LanguagePicker.vue";
import { CreateANewResourceForLanguage } from "@/libs/Api/Resources";
import TextInput from "@/views/components/Utils/TextInput.vue";
import {
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormFile,
  BImg,
} from "bootstrap-vue";
</script>
<style>
.custom-delete-btn {
  position: absolute !important;
  right: 0 !important;
  top: 0 !important;
}
</style>
